import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {IPagedData, IPagedSearch, IPmpInvoice, IPmpInvoiceCreate} from '@evencel/models';
import {Observable} from 'rxjs';

export const PMP_INVOICE_URL = 'pmp-invoices';

@Injectable({providedIn: 'root'})
export class PmpInvoiceService {
    httpClient = inject(HttpClient);

    post(data: IPmpInvoiceCreate): Observable<IPmpInvoice> {
        return this.httpClient.post<IPmpInvoice>(PMP_INVOICE_URL, data);
    }

    patch(data: IPmpInvoice): Observable<IPmpInvoice> {
        const url = `${PMP_INVOICE_URL}/${data._id}`;
        return this.httpClient.patch<IPmpInvoice>(url, data);
    }

    delete(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${PMP_INVOICE_URL}/${id}`);
    }

    restore(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${PMP_INVOICE_URL}/${id}/restore`);
    }

    private searchParams(data: IPagedSearch) {
        const {active, direction} = data.sort;
        const {pageIndex, pageSize} = data.page;
        let params = new HttpParams();
        params = params.append('pageIndex', `${pageIndex}`);
        params = params.append('pageSize', `${pageSize}`);
        params = params.append('sort', active);
        params = params.append('order', direction);
        params = params.append('projection', data.projection || 'dataTable');
        return params;
    }

    search(data: IPagedSearch): Observable<IPagedData<IPmpInvoice>> {
        const params = this.searchParams(data);
        return this.httpClient.post<IPagedData<IPmpInvoice>>(`${PMP_INVOICE_URL}/search`, data.condition, {params});
    }

    // searchByPmpPayments<T>(body: IPmpPaymentSearch) {
    //     return this.httpClient.post<T>(`${PMP_INVOICE_URL}/search/pmp-payments`, body);
    // }

    getOne(id: string): Observable<IPmpInvoice> {
        let params = new HttpParams();
        params = params.append('projection', `form`);
        const url = `${PMP_INVOICE_URL}/${id}`;
        return this.httpClient.get<IPmpInvoice>(url, {params});
    }

    get(data: IPagedSearch): Observable<IPagedData<IPmpInvoice>> {
        const params = this.searchParams(data);
        return this.httpClient.get<IPagedData<IPmpInvoice>>(PMP_INVOICE_URL, {params});
    }
}
